/**
 * Environment detection utilities
 * Centralized logic for determining the current deployment environment
 */

export interface EnvironmentInfo {
  isFirebaseHosting: boolean;
  isAppDomain: boolean;
  isCloudRun: boolean;
  isLocalhost: boolean;
  hostname: string;
}

export function getEnvironmentInfo(): EnvironmentInfo {
  const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
  
  const isFirebaseHosting = hostname === 'heli-ent.web.app' || hostname === 'redheli.web.app';
  const isAppDomain = hostname === 'app.redheli.com' || hostname.includes('.redheli.com');
  const isCloudRun = hostname === 'beta.redheli.com' || hostname === 'ga.redheli.com' || hostname === 'app.redheli.com';
  const isLocalhost = hostname === 'localhost' || hostname.includes('localhost');
  
  return {
    isFirebaseHosting,
    isAppDomain,
    isCloudRun,
    isLocalhost,
    hostname
  };
}

/**
 * Get the appropriate API base URL for the current environment
 */
export function getApiBaseUrl(): string {
  const env = getEnvironmentInfo();
  const mode = (import.meta && import.meta.env && import.meta.env.MODE) || 'production';
  
  // For development environment, use relative paths (served by same Express server)
  if (mode === 'development') {
    return '/api';
  }
  
  // For Firebase hosting, use relative /api path (Firebase hosting routes /api/* to Functions)
  if (env.isFirebaseHosting) {
    return '/api';
  }
  
  // For other production deployments, use current origin for API calls
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  return `${origin}/api`;
}